import request from '@/utils/request2'

// 列表(主数据列表)
export function loadGrowthValueOffsetDetailListDataApi(data) {
  return request({
    url: 'tms-web/growthValueOffsetDetail/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportGrowthValueOffsetDetailListDataApi(data) {
  return request({
    url: 'tms-web/growthValueOffsetDetail/exportByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewGrowthValueOffsetDetailApi(data) {
  return request({
    url: 'tms-web/growthValueOffsetDetail/view',
    method: 'post',
    data
  })
}
